// assets/product-card-snow.js
(function () {
  const SEL = '.pc-snow';

  class Snowfield {
    constructor(canvas) {
      this.canvas = canvas;
      this.ctx = canvas.getContext('2d');
      this.mouse = { x: null, y: null };
      this.snow = [];
      this.running = true;

      this.resizeObs = new ResizeObserver(() => this.size());
      this.resizeObs.observe(canvas.parentElement || canvas);

      this.io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            this.running = true;
          } else {
            this.running = false;
          }
        });
      }, { threshold: 0.1 });
      this.io.observe(canvas);

      // mouse from document so pointer-events:none is fine
      document.addEventListener('mousemove', (e) => {
        this.mouse.x = e.clientX;
        this.mouse.y = e.clientY;
      }, { passive: true });
      document.addEventListener('mouseleave', () => {
        this.mouse.x = this.mouse.y = null;
      }, { passive: true });

      document.addEventListener('visibilitychange', () => {
        this.running = document.visibilityState !== 'hidden';
      });

      this.size();
      this.loop();
    }

    size() {
      const rect = (this.canvas.parentElement || this.canvas).getBoundingClientRect();
      const dpr = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
      this.wCSS = Math.max(1, rect.width);
      this.hCSS = Math.max(1, rect.height);
      this.canvas.width = Math.floor(this.wCSS * dpr);
      this.canvas.height = Math.floor(this.hCSS * dpr);
      this.canvas.style.width = this.wCSS + 'px';
      this.canvas.style.height = this.hCSS + 'px';
      this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      this.makeFlakes();
    }

    makeFlakes() {
      this.snow.length = 0;
      const area = this.wCSS * this.hCSS;
      const base = Math.max(30, Math.round(area / 24000)); // ~100 on 1440x900
      const l1 = base, l2 = Math.round(base * 0.5), l3 = Math.round(base * 0.25);
      for (let i = 0; i < l1; i++) this.snow.push(this.flake(1));
      for (let i = 0; i < l2; i++) this.snow.push(this.flake(2));
      for (let i = 0; i < l3; i++) this.snow.push(this.flake(3));
    }

    flake(layer) {
      return {
        x: Math.random() * this.wCSS,
        y: Math.random() * -this.hCSS,
        r: Math.random() * (2 / layer) + 1,
        vy: Math.random() * 1.5 * layer + 0.5,
        vx: Math.random() * 0.6 - 0.3,
        o: Math.random() * 0.5 + 0.5,
        layer
      };
    }

    step(f) {
      f.y += f.vy;
      f.x += f.vx + Math.sin(f.y * 0.01) * 0.5;

      if (this.mouse.x != null) {
        // localize mouse relative to canvas
        const rect = this.canvas.getBoundingClientRect();
        const mx = this.mouse.x - rect.left;
        const my = this.mouse.y - rect.top;
        const dx = mx - f.x, dy = my - f.y;
        const dist = Math.hypot(dx, dy);
        if (dist < 150) {
          const force = (1 - dist / 150) * 0.15;
          const angle = Math.atan2(dy, dx) + Math.PI / 2;
          f.x += Math.cos(angle) * force * 12;
          f.y += Math.sin(angle) * force * 12;
        }
      }

      if (f.y > this.hCSS) { f.y = 0; f.x = Math.random() * this.wCSS; }
      if (f.x > this.wCSS || f.x < 0) f.x = (f.x + this.wCSS) % this.wCSS;
    }

    draw(f) {
      const ctx = this.ctx;
      ctx.beginPath();
      ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(255,255,255,${f.o})`;
      ctx.fill();
    }

    loop() {
      if (this.running) {
        this.ctx.clearRect(0, 0, this.wCSS, this.hCSS);
        for (let i = 0; i < this.snow.length; i++) {
          const f = this.snow[i];
          this.step(f);
          this.draw(f);
        }
      }
      requestAnimationFrame(() => this.loop());
    }
  }

  function init(root = document) {
    root.querySelectorAll(SEL).forEach(c => { if (!c.__snow) c.__snow = new Snowfield(c); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:reorder', (e) => init(e.target));
})();
